import useGetTags from './useGetTags'

export default useGetTags
